export const TERMINAL_PROVIDER = "TERMINAL";
export const APPLE_PROVIDER = "APPLE";
export const GOOGLE_PROVIDER = "GOOGLE";
export const ZUORA_PROVIDER = "ZUORA";
export const CDS = "CDS";

const NON_TERMINAL_PROVIDERS = [
    CDS,
    APPLE_PROVIDER,
    GOOGLE_PROVIDER,
    ZUORA_PROVIDER
];

const ALL_VALID_PROVIDERS = NON_TERMINAL_PROVIDERS.concat(TERMINAL_PROVIDER);

export function isAppleProvider(provider?: null | string): boolean {
    return provider === APPLE_PROVIDER;
}

export function isTerminalProvider(provider?: null | string): boolean {
    return provider === TERMINAL_PROVIDER;
}

export function isNonTerminalProvider(provider?: null | string): boolean {
    if (!provider) {
        return false;
    }

    return NON_TERMINAL_PROVIDERS.includes(provider);
}

export function hasValidSubscriptionWith(provider?: null | string): boolean {
    if (!provider) {
        return false;
    }

    return ALL_VALID_PROVIDERS.includes(provider);
}

export default {
    isAppleProvider,
    isTerminalProvider,
    isNonTerminalProvider,
    hasValidSubscriptionWith
};
